import { FC } from "react";
import { DiaryEditHeader } from "features/diary/ui/diaryTable/DiaryEditHeader";
import { HivesColItem } from "features/hives/lib/useHivesTable";
import { ColItem, ColumnSelector } from "entities/diary/model/types";

type Props = {
    items: HivesColItem[];
    onChange: (items: HivesColItem[]) => void;
};

export const HivesEditHeader: FC<Props> = ({ items, onChange }) => {
    const transformedItems = items.map(item => ({
        value: item.name,
        key: item.id as unknown as ColumnSelector,
        isSelected: item.isSelected
    }));

    const handleChange = (transformedItems: ColItem[]) => {
        const originalItems = transformedItems.map(item => ({
            name: item.value,
            id: item.key as unknown as HivesColItem["id"],
            isSelected: item.isSelected
        }));
        onChange(originalItems);
    };
    
    return <DiaryEditHeader items={transformedItems} onChange={handleChange} />;
};